export  const removeBaseUrl = (url) =>{
    const baseUrl = "https://mullenpersonalinjurylawyers.com/";
    const baseEsUrl = "https://es.mullenpersonalinjurylawyers.com/";

    try {
        const urlObj = new URL(url);
        const baseUrlObj = new URL(baseUrl);
    
        if (urlObj.hostname === baseUrlObj.hostname) {
            return urlObj.pathname + urlObj.search + urlObj.hash;
        }

        const baseEsUrlObj = new URL(baseEsUrl);
    
        if (urlObj.hostname === baseEsUrlObj.hostname) {
            return urlObj.pathname + urlObj.search + urlObj.hash;
        }

        return url?.length < 1 ? "/" : url;
    } catch (err) {
        return url;
    }
}
